import { render, staticRenderFns } from "./bargain-data.vue?vue&type=template&id=695aa43d&scoped=true&"
import script from "./bargain-data.vue?vue&type=script&lang=ts&"
export * from "./bargain-data.vue?vue&type=script&lang=ts&"
import style0 from "./bargain-data.vue?vue&type=style&index=0&lang=stylus&module=true&"
import style1 from "./bargain-data.vue?vue&type=style&index=1&id=695aa43d&lang=stylus&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "695aa43d",
  null
  
)

export default component.exports